export interface CategoryItem {
  id: string;
  name: string;
  description: string;
  icon: string;
  subGenres: string[];
  tint: string;
}

export const categories: CategoryItem[] = [
  {
    id: "adventure",
    name: "冒险",
    description: "从星海到秘境，主角们踏上未知旅程的每一个脚印都值得被记录。冒险动漫以辽阔的世界观和不断升级的挑战点燃观众的好奇心。",
    icon: "ri-compass-3-line",
    subGenres: ["奇幻冒险", "寻宝探险", "旅程成长"],
    tint: "bg-accent-100 text-accent-900",
  },
  {
    id: "romance",
    name: "爱情",
    description: "樱花树下的告白、雪夜里的歌声，爱情动漫用细腻的情绪与生活化的场景，讲述那些说不出口的心意。",
    icon: "ri-heart-3-line",
    subGenres: ["校园恋爱", "青春治愈", "成人情感"],
    tint: "bg-accent-100 text-accent-900",
  },
  {
    id: "scifi",
    name: "科幻",
    description: "机甲、星际、人工智能与近未来都市，科幻动漫把想象力推到极限，也让人类自身的问题被放大呈现。",
    icon: "ri-rocket-2-line",
    subGenres: ["机甲战斗", "星际航行", "赛博都市"],
    tint: "bg-primary-100 text-primary-900",
  },
  {
    id: "fantasy",
    name: "奇幻",
    description: "魔法学院、异世界食堂和沉睡的森林，奇幻动漫构建出规则各异的世界，让日常之外的生物与咒语成为日常。",
    icon: "ri-magic-line",
    subGenres: ["魔法学院", "异世界", "妖怪精灵"],
    tint: "bg-secondary-100 text-secondary-900",
  },
  {
    id: "hotblood",
    name: "热血",
    description: "球场、战场、擂台，只要还有一口气就不肯认输。热血动漫用密集的比赛与对抗，把燃烧感传递到屏幕之外。",
    icon: "ri-fire-line",
    subGenres: ["体育竞技", "战斗番", "成长逆袭"],
    tint: "bg-accent-100 text-accent-900",
  },
  {
    id: "suspense",
    name: "悬疑",
    description: "线索藏在每一帧画面里。悬疑动漫以推理、密室与都市奇谈为核心，让观众在信息拼接中寻找答案。",
    icon: "ri-search-eye-line",
    subGenres: ["推理探案", "都市奇谈", "心理悬疑"],
    tint: "bg-secondary-100 text-secondary-900",
  },
  {
    id: "healing",
    name: "治愈",
    description: "没有大起大落的剧情，只有一餐热饭、一场散步和一群温柔的人。治愈动漫适合在任何疲惫的夜晚打开。",
    icon: "ri-leaf-line",
    subGenres: ["日常治愈", "美食日常", "慢节奏生活"],
    tint: "bg-primary-100 text-primary-900",
  },
  {
    id: "school",
    name: "校园",
    description: "社团、走廊、天台与放学铃，校园动漫把青春里最普通的瞬间，变成最容易被记住的段落。",
    icon: "ri-graduation-cap-line",
    subGenres: ["社团日常", "搞笑校园", "青春成长"],
    tint: "bg-accent-100 text-accent-900",
  },
];

export const categoryNameToId = (name: string): string | undefined =>
  categories.find((item) => item.name === name)?.id;